"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Svgo = function Svgo(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.152 0l-.27 1.48c-.644.068-1.271.194-1.876.373L8.192.589l-1.568.65.318 1.469c-.563.307-1.094.664-1.59 1.064l-1.237-.857-1.2 1.2.857 1.238c-.4.495-.757 1.026-1.064 1.589l-1.47-.318-.65 1.567 1.265.815a10.527 10.527 0 00-.372 1.876L0 11.152v1.696l1.48.27c.069.644.194 1.271.373 1.876l-1.264.814.65 1.568 1.469-.318c.307.563.664 1.094 1.064 1.59l-.857 1.237 1.2 1.2 1.238-.857c.495.4 1.026.757 1.589 1.064l-.318 1.47 1.568.65.814-1.264c.605.178 1.232.303 1.877.371L11.152 24h1.696l.27-1.48a10.531 10.531 0 001.876-.372l.814 1.263 1.568-.65-.318-1.469a10.596 10.596 0 001.59-1.064l1.237.857 1.2-1.2-.857-1.238c.4-.495.757-1.026 1.064-1.589l1.47.318.65-1.568-1.264-.814c.178-.605.304-1.232.371-1.877L24 12.848v-1.696l-1.48-.27a10.524 10.524 0 00-.373-1.876l1.264-.815-.65-1.567-1.469.318a10.596 10.596 0 00-1.064-1.59l.857-1.237-1.2-1.2-1.238.857c-.495-.4-1.026-.757-1.589-1.064l.318-1.47-1.568-.65-.814 1.264a10.536 10.536 0 00-1.877-.371L12.848 0zM12 2.805a9.196 9.196 0 110 18.392 9.196 9.196 0 010-18.392zm0 .968a8.227 8.227 0 100 16.454 8.227 8.227 0 000-16.454zm-.475 1.982a.644.644 0 01.644.643.644.644 0 01-.144.405l1.364 1.376a.805.805 0 01.514-.187.805.805 0 01.23.034l.383-.968a.644.644 0 01-.343-.569.644.644 0 01.644-.643.644.644 0 01.644.643.644.644 0 01-.644.644.644.644 0 01-.17-.024l-.384.97a.805.805 0 01.445.718.805.805 0 01-.805.805.805.805 0 01-.57-.238l-1.214 1.013a1.61 1.61 0 01.331.975 1.61 1.61 0 01-.486 1.152l.875.98a1.127 1.127 0 01.699-.243 1.127 1.127 0 011.126 1.126 1.127 1.127 0 01-.033.264l1.556.523a.805.805 0 01.729-.465.805.805 0 01.804.805.805.805 0 01-.804.804.805.805 0 01-.805-.804.805.805 0 01.028-.208l-1.55-.52a1.127 1.127 0 01-1.051.728 1.127 1.127 0 01-.526-.131l-.696 1.288a.805.805 0 01.362.67.805.805 0 01-.804.806.805.805 0 01-.805-.805.805.805 0 01.805-.805.805.805 0 01.319.066l.7-1.294a1.127 1.127 0 01-.482-.922 1.127 1.127 0 01.323-.789l-.876-.981a1.61 1.61 0 01-1.017.364 1.61 1.61 0 01-.883-.265l-.78 1.082a1.127 1.127 0 01.413.87 1.127 1.127 0 01-1.127 1.127 1.127 1.127 0 01-1.127-1.127 1.127 1.127 0 011.127-1.126 1.127 1.127 0 01.6.174l.78-1.083a1.61 1.61 0 01-.613-1.261 1.61 1.61 0 01.045-.368l-1.68-.473a.805.805 0 01-.75.52.805.805 0 01-.805-.804.805.805 0 01.804-.805.805.805 0 01.805.805.805.805 0 01-.014.15l1.677.471a1.61 1.61 0 011.528-1.106 1.61 1.61 0 011.188.527l1.214-1.013a.805.805 0 01-.145-.459.805.805 0 01.19-.52l-1.362-1.375a.644.644 0 01-.401.14.644.644 0 01-.644-.644.644.644 0 01.644-.643z"
  }));
};

Svgo.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Svgo.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Svgo;
exports["default"] = _default;